<template>
  <div class="load-more">
    <div class="load-area">
      <loading :boxSize="[36,36]" />
      <span>加载中...</span>
    </div>
  </div>
</template>

<script>
import Loading from './loading.vue';
export default {
  name: 'is-loading',
  components: { Loading },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreat() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang='scss' scoped>
.load-more {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #919599;
  .load-area {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      padding-left: 7px;
    }
  }
}
</style>
